import { makeRequest } from "src/services/restcall";
import { ApiResponse } from "src/services/types";
import HttpMethod from '../../services/httpMethods'

export async function getAllCountryAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/catalogue/country', {})}

export async function getAllCitiesByCountryAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/catalogue/city?id='+value, {})
}

export async function getReleasesAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/catalogue/releases', {})}
